import { useEffect, useState } from 'react';

const useAntiScraping = () => {
  const [isBot, setIsBot] = useState(false);
  const [accessCount, setAccessCount] = useState(0);

  useEffect(() => {
    // Very basic bot detection - only catch obvious automated tools
    const detectBot = () => {
      // Only check for the most obvious automation indicators
      const isHeadless = navigator.webdriver || 
                        window.phantom || 
                        window._phantom;
      
      if (isHeadless) {
        setIsBot(true);
      }
    };

    // Rate limiting: 50 pages per session, 12 requests per minute
    const checkRateLimit = () => {
      const currentCount = parseInt(sessionStorage.getItem('meyar_access_count') || '0');
      const MAX_REQUESTS = 50;
      
      if (currentCount > MAX_REQUESTS) {
        return false;
      }
      
      sessionStorage.setItem('meyar_access_count', (currentCount + 1).toString());
      setAccessCount(currentCount + 1);
      return true;
    };

    detectBot();
    checkRateLimit();
  }, []);

  return {
    isBot,
    accessCount
  };
};

export default useAntiScraping;